let obj = {
    "1": [
        { "lat": 24.725004, "lng": 121.107788 },
        { "lat": 24.722509, "lng": 121.151047 },
        { "lat": 24.777383, "lng": 121.170273 },
        { "lat": 24.783618, "lng": 121.242371 },
        { "lat": 24.823509, "lng": 121.297989 },
        { "lat": 24.839711, "lng": 121.326828 },
        { "lat": 24.857157, "lng": 121.336441 },
        { "lat": 24.879585, "lng": 121.367340 },
        { "lat": 24.923181, "lng": 121.416092 },
        { "lat": 24.888928, "lng": 121.532822 },
        { "lat": 24.916331, "lng": 121.680450 },
        { "lat": 24.834726, "lng": 121.752548 },
        { "lat": 24.761797, "lng": 121.684570 },
        { "lat": 24.751196, "lng": 121.634445 },
        { "lat": 24.658874, "lng": 121.569901 },
        { "lat": 24.617057, "lng": 121.615219 },
        { "lat": 24.582720, "lng": 121.808167 },
        { "lat": 24.554618, "lng": 121.874771 },
        { "lat": 24.480275, "lng": 121.874084 },
        { "lat": 24.415892, "lng": 121.806107 },
        { "lat": 24.256981, "lng": 121.755295 },
        { "lat": 24.182463, "lng": 121.681137 },
        { "lat": 24.138608, "lng": 121.673584 },
        { "lat": 24.153019, "lng": 121.603546 },
        { "lat": 23.971195, "lng": 121.517029 },
        { "lat": 23.954881, "lng": 121.471710 },
        { "lat": 23.841882, "lng": 121.442871 },
        { "lat": 23.689805, "lng": 121.381073 },
        { "lat": 23.512367, "lng": 121.348114 },
        { "lat": 23.348560, "lng": 121.291809 },
        { "lat": 23.175714, "lng": 121.216278 },
        { "lat": 23.142886, "lng": 121.168213 },
        { "lat": 23.094891, "lng": 121.148987 },
        { "lat": 23.011492, "lng": 121.120148 },
        { "lat": 22.917923, "lng": 121.088562 },
        { "lat": 22.835680, "lng": 121.067963 },
        { "lat": 22.773649, "lng": 121.028137 },
        { "lat": 22.724257, "lng": 121.021271 },
        { "lat": 22.664710, "lng": 121.018524 },
        { "lat": 22.584851, "lng": 120.955353 },
        { "lat": 22.469416, "lng": 120.918274 },
        { "lat": 22.381825, "lng": 120.892181 },
        { "lat": 22.308155, "lng": 120.861969 },
        { "lat": 22.284014, "lng": 120.908661 },
        { "lat": 22.036003, "lng": 120.916901 },
        { "lat": 21.968519, "lng": 120.872955 },
        { "lat": 21.992715, "lng": 120.769958 },
        { "lat": 22.188677, "lng": 120.712280 },
        { "lat": 22.364046, "lng": 120.634003 },
        { "lat": 22.691319, "lng": 120.666962 },
        { "lat": 22.823023, "lng": 120.666962 },
        { "lat": 22.891358, "lng": 120.669708 },
        { "lat": 22.906538, "lng": 120.590057 },
        { "lat": 22.964716, "lng": 120.557098 },
        { "lat": 23.005172, "lng": 120.529633 },
        { "lat": 23.101207, "lng": 120.566711 },
        { "lat": 23.219893, "lng": 120.525513 },
        { "lat": 23.329646, "lng": 120.515900 },
        { "lat": 23.390161, "lng": 120.580444 },
        { "lat": 23.449388, "lng": 120.651855 },
        { "lat": 23.526218, "lng": 120.682068 },
        { "lat": 23.527477, "lng": 120.842743 },
        { "lat": 23.780318, "lng": 120.848236 },
        { "lat": 23.782831, "lng": 120.927887 },
        { "lat": 23.870769, "lng": 120.885315 },
        { "lat": 23.926013, "lng": 120.911407 },
        { "lat": 23.920992, "lng": 120.996552 },
        { "lat": 23.979979, "lng": 121.006165 },
        { "lat": 24.067782, "lng": 120.953979 },
        { "lat": 24.080321, "lng": 120.908661 },
        { "lat": 24.153019, "lng": 120.893555 },
        { "lat": 24.290782, "lng": 120.932007 },
        { "lat": 24.319568, "lng": 120.897675 },
        { "lat": 24.342092, "lng": 120.837250 },
        { "lat": 24.449025, "lng": 120.888062 },
        { "lat": 24.480900, "lng": 120.880508 },
        { "lat": 24.568982, "lng": 120.923080 },
        { "lat": 24.648889, "lng": 120.947800 },
        { "lat": 24.692567, "lng": 120.959473 }
    ]
}

export default obj;


// WEBPACK FOOTER //
// ./src/redArea.js